export default __webpack_public_path__ + "static/media/nesrine.84cefa03.png";